import { CommonModule } from '@angular/common';
import { Component, ViewChild, computed, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CanPipe } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import { PermissionsEnum } from 'mbs-ui-shared@models';
import { ConnectionType } from 'mbs-ui-shared@models/ConnectionType';
import { map, shareReplay } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-remote-connection-desktop-license-select-modal',
  templateUrl: './remote-connection-desktop-license-select-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    CanPipe,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class RemoteConnectionDesktopLicenseSelectModalComponent {
  private computersFacade = inject(ComputersFacade);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  type = signal<ConnectionType>(null);
  isWebRTC = computed(() => this.type() === ConnectionType.WebRTC);
  readonly alertType = MbsPopupType;
  readonly permissionsEnum = PermissionsEnum;

  limitRMMCEExceeded$ = this.computersFacade.checkRmmCeLimit().pipe(
    map((limit) => limit.limitExceeded),
    shareReplay(1)
  );

  ngAfterViewInit(): void {
    if (this.baseModal.data) {
      this.type.set(this.baseModal.data.type);
    }
  }
}
